/**
 * The partner wall. The bundled logos are placeholder brands and stand only
 * until the CMS has answered: from then on this list is exactly what the CMS
 * publishes, in its order, and empty means the section is not shown.
 */

export interface PartnerLogo {
    name: string;
    /** Logo for the light band the wall sits on. */
    logo: string;
    /** Where the mark links, if anywhere. */
    href?: string;
}

/** The partner marks the CMS publishes. */
export const PARTNERS: PartnerLogo[] = [];

/** `budgit.org` or `https://budgit.org/` → a link the browser can follow; empty stays empty. */
export const siteHref = (site: string): string | undefined => {
    const s = site.trim();
    if (!s) return undefined;
    return /^https?:\/\//.test(s) ? s : `https://${s}`;
};
